const initialState = "init";

export default function (state = initialState, action) {
    return action.type
}
